import { createClient as createSupabaseClient } from '@supabase/supabase-js'
import type { SupabaseClient } from '@supabase/supabase-js'
import { isTauri, createTauriStorage } from './tauri-storage'

// シングルトンインスタンス
let supabaseInstance: SupabaseClient | null = null

// Tauri用ストレージインスタンス（一度だけ作成）
let tauriStorageInstance: ReturnType<typeof createTauriStorage> | null = null

function getStorage() {
  if (typeof window === 'undefined') return undefined

  // Tauri環境の場合はカスタムストレージを使用
  if (isTauri()) {
    if (!tauriStorageInstance) {
      tauriStorageInstance = createTauriStorage()
    }
    return tauriStorageInstance
  }

  // Web環境の場合はlocalStorageを使用
  return window.localStorage
}

export function createClient() {
  // ブラウザ環境でのみシングルトンを使用
  if (typeof window !== 'undefined' && supabaseInstance) {
    return supabaseInstance
  }

  const isTauriEnv = isTauri()

  const client = createSupabaseClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        persistSession: true,
        storageKey: 'sb-auth-token',
        storage: getStorage(),
        autoRefreshToken: true,
        detectSessionInUrl: !isTauriEnv,
        flowType: isTauriEnv ? 'implicit' : 'pkce',
      },
    }
  )

  if (typeof window !== 'undefined') {
    supabaseInstance = client
  }

  return client
}
